import { useMutation } from 'react-query';

import { renameUserGroup } from 'api/endPoints/renameUserGroup';
import { updateUserGroup } from 'api/endPoints/updateUserGroup';

const mutationFn = (params) => {
    return renameUserGroup(params).then(() => {
        setTimeout(() => updateUserGroup(params).then(() => true), 1000);
    });
};
export const useMutationUpdateUserGroup = () => {
    return useMutation<
        unknown,
        QueryError,
        {
            group_name: string;
            roles_list: number[];
            projects_list: number[];
            customer_id: number;
            newName?: string;
        }
    >((params) => mutationFn(params));
};
